import { createSlice } from '@reduxjs/toolkit';
import { api } from 'services';
import { getFilenameFromUrl } from 'utils/helpers';
import {
  handelResponse,
  handelCatch,
  storeEventData,
  setMyNetworkDetails,
  setNetworkListData,
  setResourceCountryList,
  setConferencesList,
  storeRequestEventData,
} from '../slices';

const initialState = {};
const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
});

export const saveData = (url) => {
  var link = document.createElement('a');
  link.download = getFilenameFromUrl(url);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Event Management
export const fetchUserByEvents = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-users-by-event?eventid=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchQuartelyList =
  (id = 'IFERP') =>
    async (dispatch) => {
      try {
        const res = await api.get(
          `/admin/get-quartely-list?iferp_or_my_plan=${id}`
        );
        return await dispatch(handelResponse(res));
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };
export const fetchQuartelyDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/get-quartely-details`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchPricingCategory = () => async (dispatch) => {
  try {
    const res = await api.get('/admin/event/pricing/category/get');
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updatePricingCategory = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/pricing/category/update',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchEventPricing = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/pricing/get/details', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateEventPricing = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/pricing/update', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteEventPricing = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/event/pricing/delete`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteAddOnPricing = (formData) => async (dispatch) => {
  try {
    const res = await api.delete(`/admin/event/pricing/addon/delete`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getEventParticipants = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-event-participants', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getEventParticipantRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event-participant-request', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addEventParticipants = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/participants-member', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addParticipantsPaymentProof = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event-participant-request/upload-participants-payment-proof', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editEventParticipants = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/participants-edit', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteEventParticipants = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/participants-delete', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateUserDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-participant-request/update-userid',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const participantSendRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-participant-request/send-request',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAbstractAndAuthorDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-participant-request/get-abstract-details',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Profile Management
export const fetchUserType = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(`/user/profile/users?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAllProfiles = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/users-profile', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchParticipants = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/user-profile', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAllResourceProfiles = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/resource/get/all/profiles', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-member', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/edit-member', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-user', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportProfile = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-profile', formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Journal Management - Journal
export const fetchJournals = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-journal', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addJournal = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-journal', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editJournal = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-journal', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteJournal = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-journal', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Journal Management - Submitted Papers
export const fetchJournalPapers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/journals-submitted-papers',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchJournalPapersDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/edit-submitted-paper?papers_id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editJournalPaper = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-submitted-paper', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteJournalPaper = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-submitted-papers', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateSubmittedPapers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/update-journals-submitted-papers-status',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const resubmittedPapers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/resubmit-journal-paper', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const journalRegisteredStatusChange = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/journalRegisteredStatusChange?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportJournalPaper =
  (formData = {}) =>
    async (dispatch) => {
      try {
        const res = await api.post(
          '/admin/export-submitted-papers-data',
          formData,
          {}
        );
        const response = await dispatch(handelResponse(res));
        if (response?.data) {
          saveData(response?.data);
        }
        return response;
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };

// Journal Management - Publication Assistance
export const fetchPublicationAssistance = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-publication-assistance',
      formData,
      {}
    );

    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Award Management - Award Winners
export const fetchAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-award-winners', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAwardWinnersDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/edit-award-winner?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-award-winner', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addOldAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/old-user-add-award-winner',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-award-winner', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editOldAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/old-user-update-award-winner',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteAwardWinners = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-award-winner', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportAwardWinners =
  (formData = {}) =>
    async (dispatch) => {
      try {
        const res = await api.post(
          '/admin/export-award-winners-data',
          formData,
          {}
        );
        const response = await dispatch(handelResponse(res));
        if (response?.data) {
          saveData(response?.data);
        }
        return response;
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };

// Award Management - Nomination Details
export const fetchNomination = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-award-nominations', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editNomination = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-award-nominee', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteNomination = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-award-nomination', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportNomination =
  (formData = {}) =>
    async (dispatch) => {
      try {
        const res = await api.post(
          '/admin/export-award-nominations-data',
          formData,
          {}
        );
        const response = await dispatch(handelResponse(res));
        if (response?.data) {
          saveData(response?.data);
        }
        return response;
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };

// Chapters & Groups management - Chapters
export const fetchChapters = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-chapter', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addChapters = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-chapter', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteChapters = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-chapter', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getChaptersEventsPeople = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-chapters-events-people',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchSingleUserChapter = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-chapters', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchChapterMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-chapters-members', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportChapterMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/export-chapters-members-data',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return res;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Chapters & Groups management
export const fetchSIGGroup = () => async (dispatch) => {
  try {
    const res = await api.post('/user/network/sig-group/get', {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addSIGGroup = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/sig-group/create-edit', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteSIGGroup = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/sig-group/delete', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Resource Management
export const fetchAllResources = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-resource', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchResourceDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/edit-resource', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addResource = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-resource', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editResource = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-resource', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteResource = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-resource', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportResources = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-resource', formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportResourceData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-single-resource', formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Career Management
export const fetchAllCareer = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-career', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAppliedCareer = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/my/career/applied/details', formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteCareer = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-career', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addCareer = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-career', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editCareer = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/edit-career', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAllCareerEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-career-events', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addCareerEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-career-event', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteCareerEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-career-event', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchCareerEventMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-career-applied-members',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportCareerEventMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/export-career-applied-members',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getCareerDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/career/get/benefits/guidelines',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const careerdDeleteOrStatusUpdate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/career/delete-and-status-change',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Career management: Become keynote Speaker
// Send Invitation
export const sendInvitation = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/invite-speaker', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchInviteSpeakers = () => async (dispatch) => {
  try {
    const res = await api.get('/admin/invite-speaker-list');
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchInviteSpeakerDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/speaker-view', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update the speaker post
export const updateSpeakerPoster = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-speaker-poster', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//user side: Become keynote Speaker
//speaker-status
export const changeStatus = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/speaker-status', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//user side: Become keynote Speaker
//upload document
export const uploadDocument = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/speaker-doument', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Event Management
export const fetchAllEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-all-events', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//new API for get all event
export const fetchNewAllEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/new-get-all-event', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const getEvent = (id, temp_id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-single-event?id=${id}${temp_id ? `&temp_id=${temp_id}` : ''}`);
    const response = await dispatch(handelResponse(res));
    // const eventData = response?.data || {};
    const eventData = {
      ...(response?.data || {}),
      event_id: id,
    };
    dispatch(storeEventData(eventData));
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addEvent = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-event', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editEvent = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/edit-event-details', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteEvent = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-event', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addAgenda = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-event-agenda-session', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getSessionsByAgendaId = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-agenda-by-session?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addMyInterestSessions = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-session-to-interest', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getSession = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-single-session?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getSingleSpeaker = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-single-speaker?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getSingleCommitteeMember = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-single-committee-member?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getCommunity = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-community-details?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getNominations = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/get-nominations', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const EditNominations = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/nomination-status-change',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteNominations = (id) => async (dispatch) => {
  try {
    const res = await api.delete(`/admin/event/delete-nomination?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getSponsors = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/get-sponsors', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editSponsors = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/sponsor-status-change', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchSponsorsDetail = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/get-single-sponsor-detail',
      formData
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteSponsors = (id) => async (dispatch) => {
  try {
    const res = await api.delete(`/admin/event/delete-sponsor?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Event Management - Reviewers
export const fetchResourceReviewers = (payload) => async (dispatch) => {
  try {
    const res = await api.post(
      `/user/resource/event/reviewers/list/get`,
      payload
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const allocateAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/allocate/abstract/to/user',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchReviewrEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/users/events/as/reviewer',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchReviewrEventsAbstracts = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/get/abstracts/by/event',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteAllocatedReviewerAbstracts = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/user/resource/event/reviewers/delete/allocated/abstract?id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchReviewrDetails = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(
      `/user/resource/event/reviewers/allocated/details/get?${queryParams}`
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchMyReviewersAbstracts = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/abstracts/allocated/to/me',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Event Management - Submitted Abstracts
export const fetchSubmittedAbstracts = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/abstract/get-all', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchSubmittedAbstractsDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/event/abstract/get-single-abstract?id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteSubmittedAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/delete-abstract',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateEventsSubmittedAbstractStatus =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        '/admin/event/abstract/update-abstract-status',
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };
export const updateReSubmittAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/re-submit-event-abstract',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportSubmittedAbstracts =
  (formData = {}) =>
    async (dispatch) => {
      try {
        const res = await api.post(
          '/admin/event/abstract/export-abstract',
          formData,
          {}
        );
        const response = await dispatch(handelResponse(res));
        if (response?.data) {
          saveData(response?.data);
        }
        return response;
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };
// Event Management - Submitted Abstracts
export const fetchCommitteeMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-all-events-committee-members',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteCommitteeMembers = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/delete-single-committee-members?id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportCommitteeMembers = () => async (dispatch) => {
  try {
    const res = await api.get('/admin/export-committee-members');
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateEventAbstractStatus = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/update-submitted-status',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const updateCommitteeMemberStatus = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/status-change-committee-members',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
// Event Management - Activity Report
export const getInstituteActivityReport = (params) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/institute/activity-report/get?${params}`);
    const response = await dispatch(handelResponse(res));
    if (typeof response?.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const changeInstituteActivityReportStatus =
  (params) => async (dispatch) => {
    try {
      const res = await api.get(
        `/admin/institute/activity-report/change-status?${params}`
      );
      const response = await dispatch(handelResponse(res));
      if (typeof response?.data === 'string') {
        saveData(response?.data);
      }
      return response;
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };
export const deleteActivityReport = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/institute/activity-report/delete?id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Journal Management - Reviewers
export const fetchJournalResourceReviewers =
  (queryParams) => async (dispatch) => {
    try {
      const res = await api.get(
        `/user/resource/journal/reviewers/list/get?${queryParams}`
      );
      const response = await dispatch(handelResponse(res));
      if (response?.data && typeof response.data === 'string') {
        saveData(response?.data);
      }
      return response;
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };
export const allocateJournalAbstract = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/journal/reviewers/allocate/abstract/to/user',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchReviewrJournal = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/journal/reviewers/users/journals/as/reviewer',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchReviewrJournalPaper = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/journal/reviewers/get/abstracts/by/journal',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteJournalAllocatedReviewerAbstracts =
  (id) => async (dispatch) => {
    try {
      const res = await api.get(
        `/user/resource/journal/reviewers/delete/allocated/abstract?id=${id}`
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const fetchJournalReviewrDetails = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(
      `/user/resource/journal/reviewers/allocated/details/get?${queryParams}`
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchMyReviewersJournal = () => async (dispatch) => {
  try {
    const res = await api.get(
      '/user/resource/journal/reviewers/abstracts/allocated/to/me'
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Certificate Management - Event Certificates
export const fetchEventsRegisteredMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-events-registered_member',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const editEventCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/upload-event-certificate', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editMembershipCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/upload-membership-certificate',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editInstitutionCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/upload-institution-certificate',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const uploadEventCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event-certificate', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteEventCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/delete-certificate', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchInstitutionMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-institutions', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportEventsCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-events-members-data', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportInstitutionCertificate = () => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-institution-data');
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAmbasadorMembers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/institutions-ambassadors-details',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editAmbasadorCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/upload-institutions-ambassadors-certificate',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const exportAmbasadorCertificate = () => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/export-institutions-ambassadors-details'
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Branding Management - Branding
export const fetchAllBranding = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-branding-category', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addBranding = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/add-branding-category', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editBranding = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/update-branding-category', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteBranding = (id) => async (dispatch) => {
  try {
    const res = await api.delete(`/admin/delete-branding-category?id=${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchAllBrandingApplied = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-branding-applied-details',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteBrandingApplied = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/branding-applied-delete', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getBrandingAppliedDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-single-branding-applied-details',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editBrandingAppliedStatus = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/branding-applied-status-change',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Inbox/Notifications
export const fetchEmailReciever = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(
      `/user/inbox/notifications/receiver/users/list?${queryParams}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchInboxMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/get/message',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const sendMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/send/message',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchSingleMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/get/single/message',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const replyMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/reply/forward/message',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/delete/messages',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const starMessage = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/inbox/notifications/star/message',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Network Management - Network
export const fetchNetworkUsers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/requests/get-all-users-except-me',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchUserNetwork = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(`/user/follower/request${queryParams}`);
    const response = await dispatch(handelResponse(res));
    const followers = response?.data?.followers || [];
    const following = response?.data?.following || [];
    const receive_follow_request = response?.data?.receive_follow_request || [];
    const send_follow_request = response?.data?.send_follow_request || [];
    dispatch(
      setNetworkListData({
        followers: followers,
        following: following,
        receive_follow_request: receive_follow_request,
        send_follow_request: send_follow_request,
        isPageLoading: false,
      })
    );
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchFollowerOrFollowing = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/requests/follower-following',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchRequests = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/requests/pending-follower-following',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchMyDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/requests/my-details', formData);
    const response = await dispatch(handelResponse(res));
    dispatch(setMyNetworkDetails(response?.data || {}));
    return response;
    //
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const sendRequests = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/requests/send', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const acceptRequests = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/requests/accept-reject',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
// Network Management - Feedback
export const getFeedback =
  (queryString = '') =>
    async (dispatch) => {
      // console.log('✌️/admin/feedbacks/get${queryString} --->', `/admin/feedbacks/get${queryString}`);
      try {
        const res = await api.get(`/admin/feedbacks/get${queryString}`);
        return await dispatch(handelResponse(res));
      } catch (error) {
        return dispatch(handelCatch(error));
      }
    };
export const editProfile = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/edit-profile', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//new API for admin dashboard
//for member counts
export const getMemberCount = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/get-member-count', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//for member’s analytics
export const getMemberAnalytics = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/get-member-analytics', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//for country wise analytics
export const getCountryAnalytics = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/get-member-by-country', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//for Mentorship Statistics Chart Data
export const getMentorshipStatisticsChartData =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post('/user/get-mentors-analytics', formData);
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

//for country wise analytics
export const getMembersAnalyticsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/get-member-analytics', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const getDashboard = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(`/user/dashboard${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addEditUniversity = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/add-update-university', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const addEditInstitution = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/add-update-institution', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getOtherUniversities = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/get-other-universities', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const mapUniversity = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/university-mapping', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getOtherInstitutions = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/get-other-institutions', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const mapInstitution = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/institution-mapping', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getGroupFollowers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/sig-group/group-details',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//region management
//get country
export const getAllCountries = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/country/list?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add-edit country
export const addUpdateCountry = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/country/add-edit?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//delete country
export const deleteCountry = (id) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/country/delete`, id);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get state
export const getAllStates = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/state/list?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add-edit state
export const addUpdateState = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/state/add-edit?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//delete state
export const deleteState = (id) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/state/delete`, id);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get city
export const getAllCities = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/city/list-search?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add-edit city
export const addUpdateCity = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/city/add-edit?${queryParams}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//delete city
export const deleteCity = (id) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/city/delete`, id);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//currency conversion
export const updateCurrency = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/store-exchange-rate', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchPendingPayments = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/mentorship/bank-transfer', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const exportBankTransferPending = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/mentorship/bank-transfer-pending-export',
      formData
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const setBankTransferStatus = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/mentorship/bank-transfer-status',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchTopCitations = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/posts/top-cation', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAllCitations = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/network/posts/cation-list', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const downloadCitationFormat = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/network/posts/cation-fromat-dwonload',
      formData
    );
    const response = await dispatch(handelResponse(res));
    // if (response?.data?.file_path) {
    //   saveData(response?.data?.file_path);
    // }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//news letter

export const fetchNewsLetter = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/subscribe-user-data', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const exportNewsLetter = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/export-subscribe-user-data',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const updateNewsLetter = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/edit-subscribe-user-data', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const deleteNewsLetter = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/delete-subscribe-user-data',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//news notification
export const fetchNewsNotificationList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/advertisement`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const createAdvertisement = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/advertisement/store`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const updateSingleAdvertisement = (id, formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/advertisement/update/${id}`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const deleteSingleAdvertisement = (id) => async (dispatch) => {
  try {
    const res = await api.delete(`/admin/advertisement/delete/${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get departments
export const getAllDepartments = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/get-department`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// common API for add department and update department
export const addingDepartments = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/add-department`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// update department
// export const updateDepartments = (id, formData) => async (dispatch) => {
//   try {
//     const res = await api.post(`/admin/update-department/${id}`, formData);
//     return await dispatch(handelResponse(res));
//   } catch (error) {
//     return dispatch(handelCatch(error));
//   }
// };

//delete department
export const deleteDepartments = (id, formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/delete-department/${id}`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add topic
export const addTopics = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/add-topics`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update topic
// export const updateTopic = (formData) => async (dispatch) => {
//   try {
//     const res = await api.post(`/admin/update-topics`, formData);
//     return await dispatch(handelResponse(res));
//   } catch (error) {
//     return dispatch(handelCatch(error));
//   }
// };

// delete topic
// export const deleteTopic = (formData) => async (dispatch) => {
//   try {
//     const res = await api.post(`/admin/delete-topics`, formData);
//     return await dispatch(handelResponse(res));
//   } catch (error) {
//     return dispatch(handelCatch(error));
//   }
// };

//bulk Uploading of topic
export const bulkAddTopics = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/add-department-topic-by-excel`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//common for topic update, delete and topic map in department
export const commonFunctionalityTopic = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/topics`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//logs management module
// get sessions and logs data
export const fetchSessionsLogsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/log-activity`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get single session detail
export const fetchSingleSessionData = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/single-session-activity/${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get single log detail
export const fetchSingleLogData = (id, formData) => async (dispatch) => {
  try {
    const res = await api.post(`/single-log-activity/${id}`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//export all user logs data
export const exportLogsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/log-export`, formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//export single user logs data
export const exportSingleUserLogs = (id, formData) => async (dispatch) => {
  try {
    const res = await api.post(`/single-log-export/${id}`, formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// store user activity
export const storeUserActivities = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/store-log-activity`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//user profile details for admin
export const profileDetailsOfUsers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/user/resource/user-profiles-details`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update the user details by admin and resource
export const UpdateDetailsOfUsers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/edit-member`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//feedback reply
export const feedbackReply = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/feedbacks/reply`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//profile delete request
export const handleDeleteProfileRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/delete-user`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//All reports
export const getAllReportsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/get-all-report`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//export all reports data
export const exportAllReports = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/export-all-report', formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// get data for reports by user type
export const getAllUserTypeReportData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/get-all-user-by-type`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// add and edit comment in reports section
export const addEditComments = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/add-comment`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// export user's report by user type
export const exportUserReports = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/export-all-user-by-type`, formData, {});
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//campaign management
export const getCampaignData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/campaign-action-log/all`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//export campaign logs
export const exportCampaignLogs = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/campaign-action-log/export',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//store remark
export const handleStoreRemarks = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/campaign-action-remark`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// countries for resource user
export const resourceCountriesList = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/resource/get-resource-country', formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      dispatch(setResourceCountryList(response?.data || []));
    }
  } catch (error) {
    return await dispatch(handelCatch(error));
  }
};

// new submitted abstract flow
// add revision
export const addRevision = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/event/update-revision-abstract',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// add remarks or lead
export const handleRemarkLead = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/add-remarks-or-lead',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Detailed view table
export const fetchDetailedViewData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/details/get-all',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//conference list
export const fetchConferencesList = (queryParams) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/event/get-event-name?${queryParams}`);
    const response = await dispatch(handelResponse(res));
    dispatch(setConferencesList(response?.data));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update abstract or revision by the resource
export const updateAbstractOrRevision = (id, formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/user/event/update-revision-abstract/${id}`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//managed proceed to next button
export const handleProceedToNext = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/process-to-next',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add comment  in overall and detail view tab
export const addComments = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/add-abstract-remarks',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// reviewer
// get all allocate reviewers list
export const handleAllocateReviewers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/allocate-abstract-paper',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// delete reviewer
export const deleteReviewer = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/unallocate-paper-from-reviewer',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// get allocate time and change submitted result status
export const fetchAllocateTimeAndChangeResultStatus =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        '/admin/event/abstract/update-abstract-status',
        formData
      );

      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };
//export my task data
export const exportMyTaskData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/export-allocate-abstract-paper',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// get details og my task
export const fetchDetailsOfTask = (id) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/get-single-reviewer-abstract',
      id
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// change status of my task
export const handleAcceptanceStatusOfTask = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/change-status-of-submited-paper',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// generate evolution report of task
export const generateEvolutionReport = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/resource/event/reviewers/store-reviewer-paper-result',
      formData
    );

    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// acceptance state: generate template
export const generateAcceptanceTemplate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/update-abstract-status',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// FollowupsSuggestionData Get
export const getFollowupsSuggestionData = (payload) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event/abstract/get-followups-suggestion',
      payload
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Registration State
// send templates and followups data
export const sendFollowUpsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/send-followups-alert`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// ressend templates and followups data
export const reSendFollowUpsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/resend-followups-alert`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//single and bulk payment
export const singleBulkRegistrationPayment = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/registration/payment`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// fetch the details for the bulk payment
export const fetchDetailsOfBulkPayment = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/event/abstract/bulk-papers`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// fetch attendance list in the attendance table
export const fetchAttendancesList =
  (payloadID, formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/event/get-all-registered-user`,
        formData
      );
      const response = await dispatch(handelResponse(res));
      if (payloadID?.isExport && response?.data) {
        saveData(response?.data);
      }
      return response;
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

// taking the attendance =
export const takingAttendance = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/event/mark-attended`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// admin side fetch the membership type change list
export const fetchAllMembershipChangeList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-all-membership-request',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// handle the membership request
export const handleMembershipRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/action-on-membership-reqeust',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//get price categories
export const fetchEventPriceCategories = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-all-or-single', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update price categories
export const updateEventPriceCategories = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/store-pricing-category', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update price categories
export const getEventRegistrationDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/single-event-request', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//accept & reject event price
export const manageEventRegistrationRequest =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        '/admin/action-on-event-request',
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

// get resources for the pending request
export const getPendingRequestResources = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/even/pending-request/resource`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// get source list
export const getSourceList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/users-source`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//segment management
//get list
export const fetchAllSegment = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/get-all-segment`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//export get list

export const exportAllSegment = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/get-all-segment`, formData);
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//add update segment
export const manageSegment = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/store-or-edit`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//segment details
export const fetchSegmentDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/segment/single-event-segments`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//segment details users list
export const singleSegmentUserList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/single-segment-users`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//delete signle and multiple segment users
export const deleteSegmentUser = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/delete-segment-users`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const getCvCredit = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/cv-credits/get-all', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//segment user list for dropdown
export const fetchAddSegmentUserList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/segment/segment-users-list`, formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const editCvCredit = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/cv-credits/store', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// add the segment users
export const addSegmentUsers = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/segment/allocate-user-for-segment`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//RBAC
//fetch users list
export const fetchRBACUserList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/role-permission/get-all-users`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// export rbac user list
export const exportRBACUserList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/role-permission/get-all-users',
      formData,
      {}
    );
    const response = await dispatch(handelResponse(res));
    if (response?.data) {
      saveData(response?.data);
    }
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//fetch user permission
export const fetchRBACUserPermission = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/role-permission/get-user-permission`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//store user permission
export const updateRBACUserPermission = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/role-permission/store-user-permission`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// get resources for the pending request
export const handleGetDepartmentList = (payload) => async (dispatch) => {
  try {
    const res = await api.post(
      `/user/resource/event/reviewers/department-list`,
      payload
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Event Managment -Event -Resource Allocation
export const fetchResourceAllocation = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-event-papers', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchResourceData = (payload) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/get-event-resource-details`, payload);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Event Managment -Event -Resource Allocation
export const handleResourceAllocation = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/reallocate-abstract', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Event Add On Services
export const handleAddOnServicesData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/store-services', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAddOnServicesData = (event_id) => async (dispatch) => {
  try {
    const res = await api.post(`/admin/event/get-services`, event_id);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const deleteOnServicesData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/delete-service', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAddOnServicesRequestData =
  (request_id) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/event/get-service-request`,
        request_id
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleAddOnServicesRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/store-services', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchInstantPassData = (event_id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/event/get-event-passes?event_id=${event_id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleCallhippoCall = (payload) => async (dispatch) => {
  try {
    const res = await api.post('/admin/quick-call', payload, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleFetchCallData = (payload) => async (dispatch) => {
  try {
    const res = await api.post('/admin/get-callhippo-logs', payload, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Followups And Discount
export const fetchUpcomingConference = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/follow-ups/get-upcoming-ongoing-conference',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchFollowupsList = () => async (dispatch) => {
  try {
    const res = await api.get('/admin/follow-ups/get-followups-list', {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchFollowupsAlert = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/follow-ups/get-followups-alert',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchFollowupsUserList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/follow-ups/get-followups-user',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchEventFollowupsStatus = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/follow-ups/event-followups-status/${id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleSendFollowUpsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/follow-ups/send-followups-alert`,
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// Raised And Recevied Request Data
export const fetchRequestData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-request/all-requests',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleSendEventRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event-request/send-request`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchRequestEventData = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/event-request/get-single-request?request_id=${id}`
    );
    const response = await dispatch(handelResponse(res));
    const eventData = response?.data || {};
    dispatch(storeRequestEventData(eventData));
    return response;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleSendOtp = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event-request/sent-request-verification-otp`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleVerifyOtpRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event-request/action-on-request`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleEventPass = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/update-event-pass', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const deleteEventPass = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/event/delete-event-pass', formData, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchEventAbstractsData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/instant-pass/event-abstracts',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAbstractDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/instant-pass/abstract-details?abstract_id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleActionOnPaper = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/instant-pass/action-on-paper',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchOtherCommitteeList = () => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-other-committee-list`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchOtherConferencePasses = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/instant-pass/committee-members',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchCoAuthorAttendancesList = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/co-authors',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchSingleCommitteeMember = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/instant-pass/get-single-committee-member?id=${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const sendHallTicketPreference = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/instant-pass/send-registration-pass',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handlePassRegenerate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/instant-pass/regenerate-registration-pass',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const getEventProcessData = (id, temp_id) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/event-progress?id=${id}${temp_id}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleEditRequestEvent = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-request/update-request',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// RBAC Create User
export const fetchUserCreationsRequestData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/user-creation-request', formData, {});
    const response = await dispatch(handelResponse(res));

    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchUserSwitchRequestData = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/user-switch-request', formData, {});
    const response = await dispatch(handelResponse(res));

    if (response?.data && typeof response.data === 'string') {
      saveData(response?.data);
    }
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleUserCreation = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/user-creation-request/create-user',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchSwitchUserDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/user-switch-request/get-single-request',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleSendRBACRequestOTP = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/user-creation-request/send-otp`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchCreateUserDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/user-creation-request/get-single-request`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleRBACVerifyOtpRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/user-creation-request/action-on-request`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const UpdateSwitchUser = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/user-switch-request/edit-switch-user-request`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Participant request Api
export const fetchParticipantRequestData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-participant-request',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchParticipantRequestDetails =
  (request_id) => async (dispatch) => {
    try {
      const res = await api.get(
        `/admin/event-participant-request/get-single-request?request_id=${request_id}`
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleVerifyParticipantOtpRequest =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/event-participant-request/action-on-request`,
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleSendParticipantOtp = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event-participant-request/send-otp`,
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//Request Received Certificate Mangement Flow
export const fetchCertificateEvents = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-certificate-request',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAllCertificateEventRequests =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        '/admin/event-certificate-request/get-all-event-requests',
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleSendCertificateRequestOtp =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/event-certificate-request/send-otp`,
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleVerifyCertificateOtpRequest =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/event-certificate-request/action-on-request`,
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const updateEventCertificateRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-certificate-request/update-certificate',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchCertificateLogDetails = (payload) => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('id', payload.id ?? '');
    queryParams.append('event_id', payload.event_id ?? '');
    queryParams.append('type', payload.type ?? '');
    queryParams.append('request_id', payload.request_id ?? '');
    queryParams.append('user_type', payload.user_type ?? '');
    queryParams.append('user_type_category', payload.user_type_category ?? '');

    const res = await api.get(
      `/admin/certificate-tracking/get-data?${queryParams.toString()}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAllTrackingCertificate = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/certificate-tracking/get-all-certificate',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};


export const fetchTrackingAnalytics = (event_id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/certificate-tracking/analytics?event_id=${event_id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchMembershipPlanUpgradationRequest =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        '/admin/membership-plan-upgradation-request',
        formData,
        {}
      );
      const response = await dispatch(handelResponse(res));
      if (response?.data && !response?.data?.membership_request) {
        saveData(response?.data);
      }
      return response;
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const fetchMembershipRequestDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/membership-plan-upgradation-request/get-single-request/${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleSendMembershipTypeChangeOtp =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/membership-plan-upgradation-request/send-otp`,
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const handleVerifyMembershipTypeChangeOtpRequest =
  (formData) => async (dispatch) => {
    try {
      const res = await api.post(
        `/admin/membership-plan-upgradation-request/action-on-request`,
        formData,
        {}
      );
      return await dispatch(handelResponse(res));
    } catch (error) {
      return dispatch(handelCatch(error));
    }
  };

export const deleteMemberTypeChangeRequest = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/membership-plan-upgradation-request/delete-request',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAbstractFullPaper = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/event/abstract/get-full-paper/${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleUpdateCoAuthor = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/store-or-update-co-author`, formData, {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handleUpdateAddOnService = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/update-add-on-service`, formData, {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};


export const handleRemoveAddOnService = (id) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/delete-add-on-service/${id}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchWhatsappChatSidebarData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/get-chat-details',
      formData,
      {}
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAllTemplateData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-template/get-all-template',
      formData,
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const updateTemplateData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-template/edit-or-create-template',
      formData,
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};


export const fetchHistoryTemplateData = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/admin/event-template/get-mail-template-history',
      formData,
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAuthorDetails = (id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/admin/event-participant-request/get-user-details/${id}`,
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchUserActivitySummary = (userId) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-user-activity-summary/${userId}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchUserProfileData = (userId) => async (dispatch) => {
  try {
    const res = await api.get(`/admin/get-user-details/${userId}`);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchAuthorEmailReciever = (queryParams) => async (dispatch) => {
  try {
    const res = await api.post(
      `/admin/event/abstract/get-all?${queryParams}`
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export default adminSlice.reducer;
